















































































































































































































































































































































































































































































































































































































import {
    Component,
    Prop,
    Vue,
    Watch
} from "vue-property-decorator";
import * as modules from "../../../store/decorator";
import {
    camelCase,
    countBy,
    flow,
    method
} from "lodash";
import {
    schema
} from "../../data/schema-cctv";
import fileSize from "../../../utils/services/file-size";
@Component({
    inject: ["$validator"],
    components: {
        vStepper: () => import(
            /* webpackChunkName: "stepper" */
            "../../components/shared/Stepper.vue"),
        vueUpload: () => import(
            /* webpackChunkName: "vueUpload" */
            "../../components/shared/VueUpload.vue"),
        skipUploadDialog: () => import(
            /* webpackChunkName: "vueUpload" */
            "../../components/base/DialogSkipUpload.vue")
    },
    async beforeRouteLeave(to: any, from: any, next: any) {
        // @ts-ignore - yes ts, this is a property on the component!
        if (this.dirty) {
            if (window.confirm("Do you really want to leave? You have unsaved changes!")) {
                window.onbeforeunload = null;
                next();
            } else {
                next(false);
            }
        } else {
            next();
        }
    }
})
export default class CCTV extends Vue {
    @Prop(Object) network!: object;
    state: number = 1;
    steps: Array < object > = [{
        title: "Details"
    }, {
        title: "Videos"
    }, {
        title: "Data"
    }, {
        title: "Images"
    }, {
        title: "PDF Report"
    }, {
        title: "Plans"
    }, {
        title: "Summary"
    }];
    loading: boolean = false;
    data: any = {};
    ids: any = {};
    uploadedFiles: Array < object > = [];
    pendingFiles: Array < any > = [
        [],
        [],
        [],
        [],
        [],
        []
    ];
    invalidFiles: Array < any > = [];
    duplicateFiles: Array < any > = [];
    uploadedFilesName: Array < any > = [];
    skipUploadReasons: Array < any > = ["", "", "", "", "", ""];
    details: boolean = true;
    fieldData: any = [];
    dirty: boolean = false;
    showSkipUploadDialog: boolean = false;
    newSubdivisions: boolean = false;
    zipOnly: boolean = false;
    fileOnly: boolean = false;
    showZipDialog: boolean = false;
    fileNotUploaded: boolean = false;
    showInvalidDialog: boolean = false;
    @Watch("fields", {
        deep: true
    })
    onChange(newValue: any, oldValue: any) {
        this.dirty = Object.keys(this.fields).some(key => this.fields[key].dirty || !this.fields[key].pristine);
    }
    mounted() {
        if (document.querySelector(".n-inspection-purpose")) {
            document.querySelector(".n-inspection-purpose") !.innerHTML = "";
        }
        modules.root.hideFab();
        if (this.$route.query.type == "miscellaneous") {
            this.steps = [{
                title: "Details"
            }, {
                title: "Files"
            }, {
                title: "Summary"
            }];
        }
        window.onbeforeunload = () => "You have unsaved changes!";
    }
    beforeDestroy() {
        if (document.querySelector(".n-inspection-purpose")) {
            document.querySelector(".n-inspection-purpose") !.innerHTML = "";
        }
        modules.root.showFab();
    }
    get schema() {
        return schema[this.$route.query.type as any];
    }
    formatsize(filesize: any) {
        var thresh = 1000;
        if (Math.abs(filesize) < thresh) {
            return filesize + " B";
        }
        var units = ["KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
        var u = -1;
        do {
            filesize /= thresh;
            ++u;
        } while (Math.abs(filesize) >= thresh && u < units.length - 1);
        return filesize.toFixed(1) + " " + units[u];
        // return fileSize(filesize).human()
    }
    goToSummary() {
        this.state = this.steps.length;
        this.showZipDialog = false;
        this.loading = false;
    }
    process(customState: boolean) {
        this.$validator.validate().then(async result => {
            if (!result) {
                return modules.root.snackbar("Check required fields");
            }
            this.dirty = false;
            this.loading = true;
            this.fieldData = [];
            const type: any = this.$route.query.type;
            Object.entries(this.data).forEach(([key, val]) => {
                const value: any = val;
                value.valueString = value.value;
                if (value.title !== "Client Contact") {
                    if (value.title !== "Upload ID") this.fieldData.push(value);
                } else {
                    this.fieldData.push({
                        title: value.title,
                        value: {
                            email: value.value
                        },
                        valueString: value.value
                    });
                }
            });
            let targetIndex = this.state - 1;
            if (!customState) {
                if (this.newSubdivisions && this.state == 3) {
                    targetIndex = 5;
                }
                if (this.state > 1 && this.countValidFiles(this.pendingFiles[targetIndex]) < 1) {
                    if (this.newSubdivisions) {
                        this.fileNotUploaded = true;
                    } else {
                        this.showSkipUploadDialog = true;
                    }
                    if (this.$route.query.type == "miscellaneous") {
                        this.fileNotUploaded = true;
                    }
                    return;
                }
                if (this.state == 2 && this.countValidFiles(this.pendingFiles[0]) > 0) {
                    this.showZipDialog = true;
                    return;
                }
            }
            if (!this.newSubdivisions && this.countValidFiles(this.pendingFiles[targetIndex]) > 0) {
                this.skipUploadReasons[targetIndex] = "";
            }
            // fieldData why not uploading fieldset
            if (!this.newSubdivisions) {
                this.fieldData.push({
                    title: "Videos",
                    value: this.skipUploadReasons[1]
                });
                this.fieldData.push({
                    title: "Data",
                    value: this.skipUploadReasons[2]
                });
                this.fieldData.push({
                    title: "Images",
                    value: this.skipUploadReasons[3]
                });
                this.fieldData.push({
                    title: "PDF Report",
                    value: this.skipUploadReasons[4]
                });
                this.fieldData.push({
                    title: "Plans",
                    value: this.skipUploadReasons[5]
                });
            }
            this.fieldData.push({
                title: "Total Files Uploaded",
                value: this.uploadedFiles.length,
                valueString: this.uploadedFiles.length
            });
            await this.$http.put(process.env.VUE_APP_V3_CCTV_UPLOAD_FORM, {
                fieldData: this.fieldData,
                type: type ? type.toUpperCase() : (typeof this.$route.query.type === 'string' ? this.$route.query.type.toUpperCase() : 'UNKNOWN'),
                uuid: this.ids && this.ids.uuid ? this.ids.uuid : '',
                customerId: modules.user.customerDetail.customerId,
                userId: modules.user.userDetail.userId
            }, {
                headers: {
                    Authorization: process.env.VUE_APP_V3_API_KEY
                }
            }).then(response => {
                this.loading = false;
                if (!customState) {
                    if (this.countValidFiles(this.pendingFiles[0]) > 0 && this.state == 2) {
                        if (this.newSubdivisions) {
                            this.state = 4;
                        } else {
                            this.state = 7;
                        }
                    } else {
                        this.state++;
                    }
                } else {
                    this.state++;
                }
                // given there are required fields in the step,
                //   set dirty for all steps after the first step
                // Could implement process dirty flags rather than
                //   just step dirty flags if need be.
                this.dirty = true;
            }).catch((error: any) => modules.root.errorAlert());
        });
    }
    prevState() {
        if (this.countValidFiles(this.pendingFiles[0]) > 0) {
            if (this.state > 2) {
                this.state = 2;
            } else {
                this.state = 1;
            }
        } else {
            this.state--;
        }
    }
    store(value: any, section: any) {
        if (section.label == "Inspection Purpose" && document.querySelector(".n-inspection-purpose")) {
            document.querySelector(".n-inspection-purpose") !.innerHTML = value;
        }
        if (section.label == "Inspection Purpose") {
            if (value == "Subdivision Compliance") {
                this.steps = [{
                    title: "Details"
                }, {
                    title: "Videos"
                }, {
                    title: "Plans"
                }, {
                    title: "Summary"
                }];
                this.newSubdivisions = true;
            } else {
                this.steps = [{
                    title: "Details"
                }, {
                    title: "Videos"
                }, {
                    title: "Data"
                }, {
                    title: "Images"
                }, {
                    title: "PDF Report"
                }, {
                    title: "Plans"
                }, {
                    title: "Summary"
                }];
                this.newSubdivisions = false;
            }
        }
        this.data[camelCase(section.label)] = {
            title: section.label,
            value: value
        };
    }
    skipUpload(group: string, e: any) {
        this.skipUploadReasons[this.state - 1] = e;
        this.showSkipUploadDialog = false;
        // this.loading = false;
        this.process(true);
        // this.state++;
    }
    hideDialog() {
        this.loading = false;
        this.showSkipUploadDialog = false;
    }
    extensionLists: Array < any > = [{
        video: ["yuv", "wmv", "webm", "vob", "svi", "roq", "rmvb", "rm", "ogv", "ogg", "nsv", "mxf", "mts", "m2ts", "ts", "mpg", "mpeg", "m2v", "mp2", "mpe", "mpv", "mp4", "m4p", "m4v", "mov", "qt", "mng", "mkv", "gifv", "gif", "flv", "f4v", "f4p", "f4a", "f4b", "flv", "drc", "avi", "asf", "amv", "3gp", "3g2", "bup", "ifo"],
        data: ["csv", "dat", "db", "db3", "dbf", "docx", "gdb", "log", "mdb", "sav", "shp", "sql", "tar", "txt", "xml", "sdf", "xls", "xlsx", "xlsm", "xlsb", "html", "xltx", "xltm"],
        report: ["ani", "anim", "apng", "art", "bmp", "bpg", "bsave", "cal", "cin", "cpc", "cpt", "dds", "dpx", "ecw", "exr", "fits", "flic", "flif", "fpx", "gif", "hdri", "hevc", "icer", "icns", "ico", "cur", "ics", "ilbm", "jbig", "jbig2", "jng", "jpeg", "jpeg-ls", "jpeg 2000", "jpeg xr", "jpeg xtt", "jpeg-hdr", "kra", "mng", "miff", "nrrd", "pam", "pbm", "pgm", "ppm", "pnm", "pcx", "pgf", "pictor", "jpg", "png", "psd", "psb", "psp", "qtvr", "ras", "rgbe", "tiff", "sgi", "tga", "ufo", "ufp", "wbmp", "webp", "xbm", "xcf", "xpm", "xwd", "ciff", "dng", "ai", "cdr", "cgm", "dxf", "eva", "emf", "gerber", "emf+", "hvif", "iges", "pgml", "svg", "vml", "wmf", "xar", "cdf", "djvu", "eps", "pdf", "pict", "ps", "swf", "xaml"],
        plan: ["ani", "anim", "apng", "art", "bmp", "bpg", "bsave", "cal", "cin", "cpc", "cpt", "dds", "dpx", "ecw", "exr", "fits", "flic", "flif", "fpx", "gif", "hdri", "hevc", "icer", "icns", "ico", "cur", "ics", "ilbm", "jbig", "jbig2", "jng", "jpeg", "jpeg-ls", "jpeg 2000", "jpeg xr", "jpeg xtt", "jpeg-hdr", "kra", "mng", "miff", "nrrd", "pam", "pbm", "pgm", "ppm", "pnm", "pcx", "pgf", "pictor", "jpg", "png", "psd", "psb", "psp", "qtvr", "ras", "rgbe", "tiff", "sgi", "tga", "ufo", "ufp", "wbmp", "webp", "xbm", "xcf", "xpm", "xwd", "ciff", "dng", "ai", "cdr", "cgm", "dxf", "eva", "emf", "gerber", "emf+", "hvif", "iges", "pgml", "svg", "vml", "wmf", "xar", "cdf", "djvu", "eps", "pdf", "pict", "ps", "swf", "xaml"],
        image: ["ani", "anim", "apng", "art", "bmp", "bpg", "bsave", "cal", "cin", "cpc", "cpt", "dds", "dpx", "ecw", "exr", "fits", "flic", "flif", "fpx", "gif", "hdri", "hevc", "icer", "icns", "ico", "cur", "ics", "ilbm", "jbig", "jbig2", "jng", "jpeg", "jpeg-ls", "jpeg 2000", "jpeg xr", "jpeg xtt", "jpeg-hdr", "kra", "mng", "miff", "nrrd", "pam", "pbm", "pgm", "ppm", "pnm", "pcx", "pgf", "pictor", "jpg", "png", "psd", "psb", "psp", "qtvr", "ras", "rgbe", "tiff", "sgi", "tga", "ufo", "ufp", "wbmp", "webp", "xbm", "xcf", "xpm", "xwd", "ciff", "dng", "ai", "cdr", "cgm", "dxf", "eva", "emf", "gerber", "emf+", "hvif", "iges", "pgml", "svg", "vml", "wmf", "xar", "cdf", "djvu", "eps", "pdf", "pict", "ps", "swf", "xaml"],
        zip: ["zip"]
    }];
    isValidFileType(fName: any, fType: any) {
        return (this.extensionLists[0][fType].indexOf(fName.toLowerCase().split(".").pop()) > -1);
    }
    isFileExist(arr: any, item: any) {
        let hasResult = false;
        arr.find((o: any, i: number) => {
            if (o.uploaded && o.title == item.name && o.subtitle == item.size && o.lastModified == item.lastModified) {
                hasResult = true;
            }
        });
        return hasResult;
    }
    getFileIndex(arr: any, fName: any) {
        let targetIndex = -1;
        arr.find((o: any, i: number) => {
            if (o.title === fName) {
                targetIndex = i;
            }
        });
        return targetIndex;
    }
    countValidFiles(arr: any) {
        let co = 0;
        arr.find((o: any, i: number) => {
            if (!o.isInvalid) {
                co++;
            }
        });
        return co;
    }
    async removeFile(groupIndex: any, item: any, index: any) {
        this.pendingFiles[groupIndex].splice(index, 1);
        this.uploadedFiles.splice(this.getFileIndex(this.uploadedFiles, item.title), 1);
        if (this.isValidFileType(item.title, "zip")) {
            this.pendingFiles[0].splice(this.getFileIndex(this.pendingFiles[0], item.title), 1);
        }
        await this.$http.post(process.env.VUE_APP_V3_CCTV_UPLOAD_DELETE, {
            fileId: item.id
        }, {
            headers: {
                Authorization: process.env.VUE_APP_V3_API_KEY
            }
        }).then(response => {}).catch((error: any) => {});
    }
    async upload(files: any) {
        let targetIndex = this.state - 1;
        if (this.newSubdivisions && this.state == 3) {
            targetIndex = 5;
        }
        let indexPrefix = this.pendingFiles[targetIndex].length;
        let reCheck = false;
        this.invalidFiles = [];
        this.duplicateFiles = [];
        for (const [index, item] of files.entries() as Array < any > ) {
            let pendingFileData = {
                title: item.file.name,
                subtitle: item.file.size,
                id: (+new Date()).toString(36) + item.file.name,
                lastModified: item.file.lastModified,
                progress: 0,
                isInvalid: false,
                invalidText: "Invalid file type",
                uploaded: false
            };
            if (this.$route.query.type != "miscellaneous") {
                let dupFileName = false;
                this.uploadedFilesName.find((o: any, i: number) => {
                    if (o == item.file.name) {
                        dupFileName = true;
                        return true;
                    }
                    return false;
                });
                if (dupFileName) {
                    pendingFileData.isInvalid = true;
                    pendingFileData.invalidText = "Duplicated file";
                }
                if (this.isFileExist(this.pendingFiles[targetIndex], item.file)) {
                    pendingFileData.isInvalid = true;
                    pendingFileData.invalidText = "Duplicated file";
                }
                if (this.state == 2) {
                    if (reCheck || this.countValidFiles(this.pendingFiles[targetIndex]) < 1) {
                        // if( item.file.type.includes('zip') ) {
                        //   this.zipOnly = true;
                        //   this.fileOnly = false;
                        // } else {
                        //   this.zipOnly = false;
                        //   this.fileOnly = true;
                        // }
                        this.fileOnly = true;
                        this.zipOnly = false;
                        reCheck = false;
                    }
                    if (
                        (this.fileOnly && !this.isValidFileType(item.file.name, "video")) || (this.zipOnly && !item.file.type.includes("zip"))) {
                        pendingFileData.isInvalid = true;
                        if (this.countValidFiles(this.pendingFiles[targetIndex]) == 0) {
                            reCheck = true;
                        }
                    }
                    if (this.zipOnly && item.file.type.includes("zip")) {
                        this.pendingFiles[0].push(pendingFileData);
                    }
                }
                if (this.newSubdivisions) {
                    if (this.state == 3 && !this.isValidFileType(item.file.name, "plan")) {
                        pendingFileData.isInvalid = true;
                    }
                } else {
                    if (this.state == 3 && !this.isValidFileType(item.file.name, "data")) {
                        pendingFileData.isInvalid = true;
                    }
                    if (this.state == 4 && !this.isValidFileType(item.file.name, "image")) {
                        pendingFileData.isInvalid = true;
                    }
                    if (this.state == 5 && !this.isValidFileType(item.file.name, "report")) {
                        pendingFileData.isInvalid = true;
                    }
                    if (this.state == 6 && !this.isValidFileType(item.file.name, "plan")) {
                        pendingFileData.isInvalid = true;
                    }
                }
            } else {
                if (this.isFileExist(this.pendingFiles[targetIndex], item.file)) {
                    pendingFileData.isInvalid = true;
                    pendingFileData.invalidText = "Duplicated file";
                }
            }
            this.pendingFiles[targetIndex].push(pendingFileData);
        }
        modules.root.createCancelToken();
        let gFileType = "";
        if (this.state == 2) {
            if (this.$route.query.type != "miscellaneous") {
                gFileType = "V";
            } else {
                gFileType = "F";
            }
        }
        if (this.state == 3) {
            if (this.newSubdivisions) {
                gFileType = "P";
            } else {
                gFileType = "D";
            }
        }
        if (this.state == 4) {
            gFileType = "I";
        }
        if (this.state == 5) {
            gFileType = "R";
        }
        if (this.state == 6) {
            gFileType = "P";
        }
        var itemsArray:any = [];
        for (const [index, item] of files.entries() as Array <any> ) {
            if (!this.pendingFiles[targetIndex][index + indexPrefix] !.isInvalid) {
                let fileName = item.file.name;
                let fileNameTotal = 0;
                if (this.uploadedFilesName.indexOf(fileName) > -1) {
                    for (var i = 0; i < this.uploadedFilesName.length; i++) {
                        if (this.uploadedFilesName[i] == fileName) fileNameTotal++;
                    }
                    if (this.uploadedFilesName.indexOf(fileName.replace('.', '_' + fileNameTotal + '.')) > -1) {
                        fileNameTotal++;
                        fileName = fileName.replace('.', '_' + fileNameTotal + '.');
                    } else {
                        fileName = fileName.replace('.', '_' + fileNameTotal + '.');
                    }
                }
                item.processed = true;
                itemsArray.push({
                    file: {
                        name: fileName,
                        type: item.file.type,
                        lastModified: item.file.lastModified
                    },
                    reticIds: this.ids,
                    fileType: gFileType
                });
            } else {
                if (this.pendingFiles[targetIndex][index + indexPrefix] !.invalidText == "Duplicated file") {
                    this.duplicateFiles.push({
                        title: this.pendingFiles[targetIndex][index + indexPrefix] !.title
                    });
                } else {
                    this.invalidFiles.push({
                        title: this.pendingFiles[targetIndex][index + indexPrefix] !.title
                    });
                }
            }
        }
        
        // Check if all files are invalid (itemsArray is empty)
        if (itemsArray.length === 0) {
            // All files are invalid, show invalid file dialog immediately
            if (this.invalidFiles.length > 0 || this.duplicateFiles.length > 0) {
                this.showInvalidDialog = true;
                this.invalidFileUpload();
            }
            return;
        }
        
        // Only show loading dialog when we have valid files to process
        modules.root.loadingAlert("Please wait...");
        
        await new Promise(async (resolve, reject) => {
            await this.$http.post(process.env.VUE_APP_V3_CCTV_UPLOAD_LOCATIONS, {
                items: itemsArray
            }, {
                headers: {
                    Authorization: process.env.VUE_APP_V3_API_KEY
                },
                cancelToken: modules.root.cancelSource.token
            }).then(response => resolve(response.data)).catch((error: any) => reject());
        })
        .then(async (locationURLs: any) => {
            var locationIndex = 0;
            for (const [index, item] of files.entries() as Array < any > ) {
                if (item.processed) {
                    item.locationURL = locationURLs[locationIndex];
                    locationIndex++;
                }
            }
        });
        await new Promise(async (resolve, reject) => {
            for (const [index, item] of files.entries() as Array <any> ) {
                if (item.processed) {
                    // Set a safety timeout for this file upload
                    const safetyTimeoutDuration = Math.max(300000, item.file.size / (1024 * 1024 * 50) * 60000);
                    const safetyTimeout = setTimeout(() => {
                        // If this timeout fires, it means onUploadProgress might not be completing
                        if (this.pendingFiles[targetIndex][index + indexPrefix] && 
                            this.pendingFiles[targetIndex][index + indexPrefix].progress < 100) {
                            
                            // Force the progressAlert to close
                            modules.root.hideAlert();
                            
                            // Mark the file as failed
                            this.pendingFiles[targetIndex][index + indexPrefix].isInvalid = true;
                            this.pendingFiles[targetIndex][index + indexPrefix].invalidText = "Upload timed out";
                            
                            // Show a timeout notification with a delay to ensure it appears
                            setTimeout(() => {
                                // Use a different alert method that requires more explicit user interaction
                                modules.root.actionAlert({
                                    title: "Upload Timeout Error",
                                    text: `The upload for "${item.file.name}" has been running for over ${Math.round(safetyTimeoutDuration/60000)} minutes without completing. It has been marked as failed. Please try again or upload a smaller file.`,
                                    destination: null, // Prevent auto-navigation
                                    confirmButtonText: "I Understand" // Custom button text
                                });
                            }, 1000); // Use a longer delay to ensure previous alerts are gone
                        }
                    }, safetyTimeoutDuration + 10000); // Add 10 seconds buffer
                    
                    await this.$http.put(item.locationURL, item.file, {
                        headers: {
                            "Content-Type": item.file.type,
                            "X-Upload-Content-Type": item.file.type
                        },
                        cancelToken: modules.root.cancelSource.token,
                        // Calculate timeout based on file size: 10 minutes per 50MB with minimum of 5 minutes 
                        // This accounts for very slow connections like Slow 4G
                        timeout: Math.max(300000, item.file.size / (1024 * 1024 * 50) * 60000),
                        onUploadProgress: (progressEvent: any) => {
                            modules.root.progressAlert({
                                title: "Uploading files...",
                                text: item.file.name,
                                progress: Math.floor(
                                    (progressEvent.loaded * 100) / progressEvent.total),
                                total: files.filter((single: any) => single.processed).length,
                                current: index + 1
                            });
                        }
                    })
                    .then(response => {
                        // Clear the safety timeout
                        clearTimeout(safetyTimeout);
                        
                        this.pendingFiles[targetIndex][
                            index + indexPrefix
                        ] !.progress = 100;
                        this.pendingFiles[targetIndex][
                            index + indexPrefix
                        ] !.uploaded = true;
                        this.pendingFiles[targetIndex][index + indexPrefix] !.id = response.data.id;
                        this.uploadedFiles.push({
                            title: item.file.name,
                            subtitle: item.file.size,
                            id: response.data.id,
                            lastModified: item.file.lastModified
                        });
                        this.uploadedFilesName.push(item.file.name);
                    }).catch((error: any) => {
                        // Clear the safety timeout
                        clearTimeout(safetyTimeout);
                        
                        // Mark the file as invalid in the UI
                        this.pendingFiles[targetIndex][
                            index + indexPrefix
                        ] !.isInvalid = true;
                        
                        // Check if it's a timeout (could be ECONNABORTED or just a long duration)
                        const isTimeout = error && (
                            (error.code === 'ECONNABORTED') || 
                            (error.message && (error.message.includes('timeout') || error.message.includes('time')))
                        );
                        
                        if (isTimeout) {
                            // This is a timeout error
                            this.pendingFiles[targetIndex][index + indexPrefix] !.invalidText = "Upload timed out";
                            
                            // Show a timeout notification with a delay to ensure it appears
                            setTimeout(() => {
                                // Use a different alert method that requires more explicit user interaction
                                modules.root.actionAlert({
                                    title: "Upload Timeout Error",
                                    text: `The upload for "${item.file.name}" has been running for over ${Math.round(safetyTimeoutDuration/60000)} minutes without completing. It has been marked as failed. Please try again or upload a smaller file.`,
                                    destination: null, // Prevent auto-navigation
                                    confirmButtonText: "I Understand" // Custom button text
                                });
                            }, 1000); // Use a longer delay to ensure previous alerts are gone
                        } else if (error && error.message && error.message.includes('cancel')) {
                            // Cancellation error
                            this.pendingFiles[targetIndex][index + indexPrefix] !.invalidText = "Upload cancelled";
                            reject("Upload cancelled");
                        } else {
                            // Mark as failed but continue with other files
                            this.pendingFiles[targetIndex][index + indexPrefix] !.invalidText = "Upload failed";
                            
                            // Show notification for general failures
                            setTimeout(() => {
                                // Force close any existing alerts
                                modules.root.hideAlert();
                                
                                // Use a different alert method that requires more explicit user interaction
                                modules.root.actionAlert({
                                    title: "Upload Failed",
                                    text: `The upload for "${item.file.name}" failed. This could be due to network issues or server problems. Please try again later.`,
                                    destination: null, // Prevent auto-navigation
                                    confirmButtonText: "I Understand" // Custom button text
                                });
                            }, 1000); // Use a longer delay to ensure previous alerts are gone
                        }
                    });
                }
            }
            if (this.invalidFiles.length > 0 || this.duplicateFiles.length > 0) {
                this.showInvalidDialog = true;
                this.invalidFileUpload();
            }
            
            // Always resolve to prevent hanging
            setTimeout(() => {
                resolve(true);
            }, 500);
        })
        .then(response => modules.root.hideAlert())
        .catch((error: any) => {
            if (error === "Upload cancelled") {
                modules.root.confirmAlert({
                    title: "Upload cancelled"
                });
            } else {
                modules.root.errorAlert();
            }
        })
        .finally(() => {
            // Ensure alert is hidden even if something goes wrong
            modules.root.hideAlert();
        });
    }

    async submit() {
        this.dirty = false;
        window.onbeforeunload = null;
        // if (window.confirm('Are you sure you want to Submit?') === false) {
        //   return;
        // }
        modules.root.loadingAlert("Submitting your upload");
        this.fieldData.push({
            title: "Total Files Uploaded",
            value: this.uploadedFiles.length,
            valueString: this.uploadedFiles.length
        });
        await this.$http.get(`${process.env.VUE_APP_DOT_NET_API_BASE_URL}${process.env.VUE_APP_DOT_NET_API_CLIENT_V3_DETAILS}/${modules.user.userDetail.email}`).then(async (response: any) => {
            await this.$http.put(process.env.VUE_APP_V3_CCTV_UPLOAD_SUBMIT, {
                fieldData: this.fieldData,
                id: response.data[0].id,
                reticIds: this.ids,
                tallyTotal: countBy(this.uploadedFiles, flow(method("title.replace", /^.*\./, "") as any))
            }, {
                headers: {
                    Authorization: process.env.VUE_APP_V3_API_KEY
                }
            }).then(response => {
                modules.root.actionAlert({
                    title: "Survey submitted",
                    text: "Your survey was successfully submitted.",
                    destination: "cctvmain"
                });
            });
        }).catch((error: any) => modules.root.errorAlert());
    }
    async invalidFileUpload() {
        await this.$http.get(`${process.env.VUE_APP_DOT_NET_API_BASE_URL}${process.env.VUE_APP_DOT_NET_API_CLIENT_V3_DETAILS}/${modules.user.userDetail.email}`).then(async (response: any) => {
            await this.$http.post(process.env.VUE_APP_V3_CCTV_UPLOAD_INVALID, {
                fieldData: this.fieldData,
                id: response.data[0].id,
                reticIds: this.ids,
                invalidTotal: countBy(this.invalidFiles, flow(method("title.replace", /^.*\./, "") as any)),
                duplicateTotal: countBy(this.duplicateFiles, flow(method("title.replace", /^.*\./, "") as any))
            }, {
                headers: {
                    Authorization: process.env.VUE_APP_V3_API_KEY
                }
            }).then(response => {});
        }).catch((error: any) => {});
    }
}
